import React from "react";
import CourseSubjects from "./course-subjects/CourseSubjects";
import "./CourseNote.scss";

export default class CourseNote extends React.PureComponent {
    render(): React.ReactNode {
        return (
            <div className="dropdown-list course-note-area course-subjects-area" style={{ height: "90vh" }}>
                <CourseSubjects />
            </div>
        );
    }
}

